import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import {
  getPayoutDetailsAction,
  getProviderScoreStatisticsNetworkAction,
  getUsageCoverageDetailsAction,
  getWidgetAction,
} from "../../../../redux/actions/NetworkIntelligenceAction";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ROUTES from "../../../../Utils/routesConstants";
import { useNavigate } from "react-router-dom";
import { isLoadingAction } from "../../../../Utils/helper";
import {
  customYAxisFormatter,
  initialStateDashboard,
  initialStateDashboardCoverage,
  initialStateDashboardPayout,
} from "./helper";
import {
  clearDuration,
  getApiParams,
} from "../../ProviderProfileDetails/helper";
import { SearchIcon } from "../../../../Utils/SvgIcons";
import DateRangePickerInput from "../../ProviderProfileDetails/DateRangePicker";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchFilter, setSearchFilter] = useState(initialStateDashboard);
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState(null);

  const globalReducer = useSelector((state) => state?.globalReducer);
  const { apiParams } = getApiParams({ globalReducer });

  const getNetworkIntelligenceReducer = useSelector(
    (state) => state?.NetworkIntelligenceReducer
  );

  const callWidgetScoreAPI = (data) => {
    dispatch(getWidgetAction(data));
    const resp = dispatch(getProviderScoreStatisticsNetworkAction(data));
    resp.then((res) => {
      setCLientGraphHandler(res);
    });
  };

  useEffect(() => {
    dispatch(getUsageCoverageDetailsAction(initialStateDashboardCoverage));
    dispatch(getPayoutDetailsAction(initialStateDashboardPayout));
    callWidgetScoreAPI(searchFilter);
  }, []);

  const setCLientGraphHandler = (res) => {
    setSeries([
      {
        name: "Score",
        data: res?.data?.results?.map((ele) => ele?.score),
      },
    ]);
    setOptions({
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      xaxis: {
        categories: res?.data?.results?.map((ele) =>
          moment(ele?.createdDate).format("DD MMM YYYY")
        ),
      },
      yaxis: {
        axisBorder: {
          show: true,
          color: "#78909C",
          offsetX: 0,
          offsetY: 0,
        },
        axisTicks: {
          show: true,
          borderType: "solid",
          color: "#78909C",
          width: 6,
          offsetX: 0,
          offsetY: 0,
        },

        labels: {
          formatter: customYAxisFormatter,
        },
      },
      tooltip: {
        y: {
          formatter: (value) => value,
        },
      },
    });
    isLoadingAction(false, dispatch);
  };

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  const handleSearch = () => {
    callWidgetScoreAPI({ ...searchFilter, ...apiParams });
  };

  const handleClear = () => {
    clearDuration(dispatch);
    callWidgetScoreAPI(initialStateDashboard);
    setSearchFilter(initialStateDashboard);
  };

  return (
    <div className="right-section" style={{ padding: "20px" }}>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row mt20">
              <div className="col-xl-9 col-lg-9 col-md-9 col-12">
                <div className="__search_box">
                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-12 my-2">
                      <select
                        className="form-select"
                        value={searchFilter?.detailType}
                        onChange={(e) =>
                          changeHandler("detailType", e.target.value)
                        }
                      >
                        <option value="">Detail Type</option>
                        <option value="Logo">Logo</option>
                        <option value="ProfileDetail">Profile Details</option>
                        <option value="ProfileVerification">
                          Profile Verification
                        </option>
                        <option value="InfrastructureDetail">
                          Infrastructure Details
                        </option>
                        <option value="StaffDetail"> Staff Details</option>
                        <option value="PaymentDetail"> Payment Details</option>
                        <option value="TestDetail"> Test Details</option>
                        <option value="PackageDetail"> Package Details</option>
                      </select>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-12 my-2">
                      <select
                        className="form-select"
                        value={searchFilter?.cityId}
                        onChange={(e) =>
                          changeHandler("cityId", e.target.value)
                        }
                      >
                        <option value={0}> City </option>
                        <option value={1}> Indore </option>
                        <option value={2}> Mumbai </option>
                        <option value={3}> Gurgaon </option>
                      </select>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-12 my-2 dashbaord-date">
                      <DateRangePickerInput />
                    </div>
                  </div>
                  <div className="_search_clear_div">
                    <div
                      className="search"
                      type="button"
                      onClick={handleSearch}
                    >
                      <a className="sidebar-links">
                        <SearchIcon />
                        <span className="sidebar-link-text">Search</span>
                      </a>
                    </div>
                    <div>
                      <p className="mb-0" type="button" onClick={handleClear}>
                        <a className="text-decoration text-highlight f-12">
                          Clear All Filters
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {getNetworkIntelligenceReducer?.getWidgetDetails?.map(
                    (ele, index) => {
                      return (
                        <div className="col-xl-4 col-sm-6" key={index}>
                          <div className="provider_card">
                            <h6> {ele?.widgetType} </h6>
                            <h2>
                              {ele?.value}
                              {ele?.widgetType === "Adoption Rate" && "%"}
                            </h2>
                            <p>
                              From 15 Days
                              <span
                                style={{
                                  color:
                                    ele?.growthRate >= 0 ? "#34d36a" : "red",
                                }}
                              >
                                {ele?.growthRate >= 0 ? (
                                  <img
                                    src="../images/arrowright.svg"
                                    alt="arrowright"
                                  />
                                ) : (
                                  <img
                                    src="../images/arrowrightred.svg"
                                    alt="arrowright"
                                  />
                                )}
                                {ele?.growthRate}%
                              </span>
                            </p>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
                <div className="__statistics_box">
                  <div className="row">
                    <h4>Information Statistics </h4>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-12 pt-1">
                      <div className="_graph_Analytics">
                        <div id="chart">
                          {series?.length !== 0 && options !== null && (
                            <Chart
                              options={options}
                              series={series}
                              height={350}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-3 col-12">
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-12 mb-3">
                    <div className="payout_box">
                      <div className="d-flex flex-wrap justify-content-between">
                        <div>
                          <h4 className="card-title mb-3"> Payouts </h4>
                        </div>
                        <div>
                          <p
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              navigate(ROUTES.NETWORK_INTELLIGENCE_SETTLEMENTS)
                            }
                          >
                            View All
                          </p>
                        </div>
                      </div>
                      {getNetworkIntelligenceReducer?.getPayoutDetails
                        .slice(0, 3)
                        ?.map((ele, index) => {
                          const isLastItem =
                            index ===
                            getNetworkIntelligenceReducer?.getPayoutDetails
                              ?.length -
                              1;
                          const bdrClass = isLastItem ? "" : "bdr__bottom";
                          return (
                            <div className={`pro_sec ${bdrClass}`} key={index}>
                              <div className="d-flex">
                                <div className="me-2">
                                  <img src={ele?.providerLogo} alt="" />
                                </div>
                                <div>
                                  <h6> {ele?.providerName} </h6>
                                  <p className="date">
                                    {moment(ele?.date).format("DD MMMM YYYY")}
                                  </p>
                                </div>
                              </div>
                              <div>
                                <p className="amount">
                                  Rs.
                                  {ele?.totalAmount?.toLocaleString("en-IN")}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                    <div className="networkurgency_box">
                      <div className="d-flex flex-wrap justify-content-between">
                        <div>
                          <h4 className="card-title mb-3">Network Urgency</h4>
                        </div>
                        <div>
                          <p
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              navigate(
                                ROUTES.NETWORK_INTELLIGENCE_USAGECOVERAGE
                              )
                            }
                          >
                            View All
                          </p>
                        </div>
                      </div>
                      <div className="d-flex flex-wrap justify-content-between">
                        <div>
                          <h5 className="mb-3"> Centre Name </h5>
                        </div>
                        <div>
                          <h5 className="mb-3"> Score </h5>
                        </div>
                      </div>
                      {getNetworkIntelligenceReducer?.getUsageCoverageDetails
                        .slice(0, 3)
                        ?.map((ele, index) => {
                          const isLastItem =
                            index ===
                            getNetworkIntelligenceReducer
                              ?.getUsageCoverageDetails?.length -
                              1;
                          const bdrClass = isLastItem ? "" : "bdr__bottom";
                          return (
                            <div
                              className={`pro_sec d-flex gap-20 justify-content-between ${bdrClass}`}
                              key={index}
                            >
                              <div className="d-flex gap-10 align-items-center">
                                <img src={ele?.providerLogo} alt="" />
                                <h6> {ele?.providerName} </h6>
                              </div>
                              <div className="d-flex gap-10">
                                <p className="amount">
                                  {ele?.providerScorePercent}
                                </p>
                                <p className="score-success">
                                  <i
                                    style={{
                                      color:
                                        ele?.providerScorePercent >= 0 &&
                                        ele?.providerScorePercent <= 50
                                          ? "red"
                                          : ele?.providerScorePercent > 50 &&
                                            ele?.providerScorePercent <= 75
                                          ? "yellow"
                                          : "green",
                                    }}
                                    className="fa-solid fa-circle"
                                  ></i>
                                </p>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
